import { useCallback, useState } from 'react';
// @mui
import LoadingButton from '@mui/lab/LoadingButton';
// components
import { ConfirmDialog } from 'src/components/custom-dialog';
// auth
import { useAuthContext } from 'src/auth/hooks';

// ----------------------------------------------------------------------
// 使用中のログイン切れの案内（AuthProvider の sessionExpired）。
//
// AuthProvider は ThemeProvider の外にあるので、ダイアログはこちらに分けて
// App.js の ThemeProvider の中に置く。
// 自動でログイン画面へ飛ばさない。再ログインはページを読み込み直すので、
// 保存していない入力を控えられるように閉じる（キャンセル）も残す。
// ----------------------------------------------------------------------

export default function SessionExpiredDialog() {
  const { sessionExpired, dismissSessionExpired, relogin } = useAuthContext();
  const [loading, setLoading] = useState(false);

  const handleRelogin = useCallback(async () => {
    setLoading(true);
    try {
      await relogin();
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  }, [relogin]);

  if (!dismissSessionExpired) return null;

  return (
    <ConfirmDialog
      open={!!sessionExpired}
      onClose={dismissSessionExpired}
      title="ログインの有効期限が切れました"
      content={
        <>
          操作を続けるには再ログインしてください。
          <br />
          再ログインするとこの画面を読み込み直すため、保存していない入力は失われます。
          必要なら内容を控えてから再ログインしてください。
        </>
      }
      action={
        <LoadingButton variant="contained" color="primary" loading={loading} onClick={handleRelogin}>
          再ログイン
        </LoadingButton>
      }
    />
  );
}
